import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text, Flex, Link } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import WhatsHappeningCard from "./WhatsHappeningCard";
const WhatsHappeningSection = ({ happenings, eventId, }) => {
    const navigate = useNavigate();
    if (!happenings || happenings.length === 0) {
        return null;
    }
    const handleViewAll = () => {
        navigate(`/event/${eventId}/whats-happening`, {
            state: { happenings, eventId: eventId }, // Pass the numeric ID
        });
    };
    return (_jsxs(Box, { width: "100%", mb: 8, scrollMarginTop: "250px", children: [_jsxs(Flex, { alignItems: "center", width: "100%", children: [_jsx(Text, { mx: 2, fontSize: "26px", color: "white", fontFamily: "Zuumerough-Regular", children: "WHAT'S HAPPENING?" }), _jsx(Box, { flex: "1", height: "1px", bg: "#3A3D43" }), happenings && happenings.length > 0 && (_jsx(Link, { color: "#7F54FB", fontSize: "14px", fontWeight: "500", mx: 2, onClick: handleViewAll, _hover: { textDecoration: "none", color: "#9F74FB" }, children: "View All Events" }))] }), _jsx(Flex, { gap: 4, overflowX: "auto", pb: 2, sx: {
                    "&::-webkit-scrollbar": {
                        height: "4px",
                    },
                    "&::-webkit-scrollbar-track": {
                        background: "#2A2A2A",
                        borderRadius: "2px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                        background: "#7F54FB",
                        borderRadius: "2px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                        background: "#9F74FB",
                    },
                }, children: happenings.map((happening) => (_jsx(WhatsHappeningCard, { happening: happening }, happening.id || Math.random()))) })] }));
};
export default WhatsHappeningSection;
